import styled from 'styled-components'

enum Rank {
  FIRST = '1st',
  SECOND = '2nd',
  THIRD = '3rd'
}

type Position = '1st' | '2nd' | '3rd'

interface TopUsesBoxStyledProps {
  position: Position
  topFrame: string
  boderFrame: string
  boderAvt: string
}

const avatarDimension = {
  default: 112,
  lg: 90,
  md: 50,
  sm: 90
}

const topStableDimension = {
  default: 270,
  xl: '100%',
  sm: 230
}

const TopStableBoxStyled = styled.div<TopUsesBoxStyledProps>`
  .top-stable {
    /* background-image: url(${({ boderFrame }) => boderFrame}); */
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    // margin-top: ${({ position }) => (position === Rank.SECOND || position === Rank.THIRD) && '77px'};

    width: ${topStableDimension.default}px;
    padding: 20px 0px 0px;

    width: 270px;
    height: 340px;
    position: relative;
    background-color: ${({ position }) => position === Rank.FIRST ? '#895d27' : (position === Rank.SECOND ? '#4e5156' : '#593c2c')};
    -webkit-clip-path: polygon(100% 0%, 70% 0%, 30% 0%, 0% 0%, 0% 25%, 0% 49%, 0% 87%, 15% 100%, 41% 100%, 61% 100%, 100% 100%, 100% 85%, 100% 50%, 100% 25%);
    clip-path: polygon(100% 0%, 70% 0%, 30% 0%, 0% 0%, 0% 25%, 0% 49%, 0% 87%, 15% 100%, 41% 100%, 61% 100%, 100% 100%, 100% 85%, 100% 50%, 100% 25%);
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 268px;
      height: 338px;
      top: 1px;
      left: 1px;
      background-color:  #121520;
      display: block;
      -webkit-clip-path: polygon(100% 0%, 70% 0%, 30% 0%, 0% 0%, 0% 25%, 0% 49%, 0% 87%, 15% 100%, 41% 100%, 61% 100%, 100% 100%, 100% 85%, 100% 50%, 100% 25%);
      clip-path: polygon(100% 0%, 70% 0%, 30% 0%, 0% 0%, 0% 25%, 0% 49%, 0% 87%, 15% 100%, 41% 100%, 61% 100%, 100% 100%, 100% 85%, 100% 50%, 100% 25%);
    }

    ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
      width: ${topStableDimension.xl};
      padding-bottom: 16px;
    }

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      background-position: top;

      padding: 18px 0;
    }

    ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
      width: ${topStableDimension.sm}px;
      padding: 30px 0;
    }

    .top-frame {
      background-image: url(${({ topFrame }) => topFrame});
      background-size: contain;
      background-repeat: no-repeat;

      height: 15px;

      top: 0;
      right: 0px;
    }
    .avatar-box {
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }

    .img-top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      top: 5px;
      position: relative;
      padding: 0px 12px;
      .medal {
        top: 40px;
        right: 10px;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          width: 28px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.md)} {
          width: 18px;
          top: 10px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          width: 24px;
          top: 14px;
          right: 14px;
        }
      }

      .vip-icon {
        position: absolute;
        top: 50px;
        right: 15px;
      }
    }

    .avatar-container {
      margin-bottom: 16px;
      width: 127px;
      aspect-ratio: 1 / 1;
      background-image: url(${({ boderAvt }) => boderAvt});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      position: relative;

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        margin-bottom: 12px;
        background-image: none;
        width: auto;
      }

      .avatar {
        width: ${avatarDimension.default}px;
        aspect-ratio: 1 / 1;
        border-radius: 150px;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          width: ${avatarDimension.lg}px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.md)} {
          width: ${avatarDimension.md}px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          width: ${avatarDimension.sm}px;
        }
      }
    }

    .name {
      font-size: 16px;
      line-height: 28px;
      position: relative;

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        font-size: 20px;
        line-height: 24px;
        margin-bottom: 20px;
      }
    }

    .achievement {
      position: relative;
    }

    .achievement-container {
      column-gap: 50px;
      margin-bottom: 40px;
      position: relative;

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        column-gap: 18px;
        margin-bottom: 20px;
      }

      .achievement {
        position: relative;
        .title {
          column-gap: 4px;

          span {
            ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
              font-size: 14px;
            }
          }

          img {
            ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
              width: 16px;
            }
          }

          .img-achievement {
            margin-top: 5px;
          }
        }

        .times {
          font-size: 24px;
          line-height: 28px;

          ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
            font-size: 18px;
            line-height: 22px;
          }
        }

        .total-uses {
          margin-top: 6px;
        }
      }
    }

    .win-rate {
      position: absolute;
      bottom: 8px;
      span {
        color: #fff;
      }
    }
  }

  .vip-icon {
    position: absolute;
    top: 0;
    right: 70px;
  }
`

export default TopStableBoxStyled
